export default "__VITE_ASSET__CRifs7yx__"